import { cn } from "@/lib/utils";

type BadgeProps = {
  children: string;
  tone?: "neutral" | "success" | "warning" | "danger";
};

const tones = {
  neutral: "bg-muted text-muted-foreground",
  success: "bg-success text-success-foreground",
  warning: "bg-warning text-warning-foreground",
  danger: "bg-destructive text-destructive-foreground"
};

export function Badge({ children, tone = "neutral" }: BadgeProps) {
  return <span className={cn("inline-flex items-center rounded px-2 py-0.5 text-xs font-medium", tones[tone])}>{children}</span>;
}
